var React = require('react');

function IconEnvelope (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.92947 6.55016L0.0176322 1.72596C0.0176322 1.76755 0 1.80914 0 1.85072V9.1494C0 10.1683 0.70529 11.0001 1.56927 11.0001H12.4307C13.2947 11.0001 14 10.1683 14 9.1494V1.85072C14 1.76755 13.9824 1.68437 13.9824 1.6012L6.92947 6.55016Z","key":0}),React.createElement("path",{"d":"M13.56 0.582231C13.2779 0.228733 12.8724 0 12.4315 0H1.57009C1.07638 0 0.65321 0.270321 0.371094 0.6862L6.93029 5.26087L13.56 0.582231Z","key":1})]);
}

IconEnvelope.defaultProps = {"viewBox":"0 0 14 11","fill":"none"};

module.exports = IconEnvelope;

IconEnvelope.default = IconEnvelope;
